module.exports = __webpack_public_path__ + "img/share-icon.f9bb385d.svg";